import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { AppComponent } from '../app.component';
import { DataService } from '../_services/data.service';
import { UserService } from '../_services/user.service';

@Component({
  selector: 'app-gestion-usuarios',
  templateUrl: './gestion-usuarios.component.html',
  styleUrls: ['./gestion-usuarios.component.scss']
})
export class GestionUsuariosComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isDtInitialized: boolean = false
  usuarios: any = [];
  usuarioEditado:any;
  usuarioLogeado:any;

  constructor(private userService: UserService,
              private dataService: DataService,
              private router: Router,
              private appComponent:AppComponent) { }

  ngOnInit(): void {
    this.usuarioLogeado=this.appComponent.usuarioLogueado?.idUsuario;
    this.getUsuarios();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 5,
      dom: 'Bfrtip',
      ordering: false,
      responsive: true,
      language: {
        processing: "Procesando...",
        search: "Buscar:",
        lengthMenu: "Mostrar _MENU_ &eacute;l&eacute;ments",
        info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
        infoEmpty: "Mostrando ningún elemento.",
        infoFiltered: "(filtrado _MAX_ elementos total)",
        infoPostFix: "",
        loadingRecords: "Cargando registros...",
        zeroRecords: "No se encontraron registros",
        emptyTable: "No hay datos disponibles en la tabla",
        paginate: {
          first: "Primero",
          previous: "Anterior",
          next: "Siguiente",
          last: "Último"
        },
        aria: {
          sortAscending: ": Activar para ordenar la tabla en orden ascendente",
          sortDescending: ": Activar para ordenar la tabla en orden descendente"
        }
      }
    };
  }

  ngOnDestroy(){
    this.dataService.datosEdicionUsuario=this.usuarioEditado;
  }

  getUsuarios() {
    this.usuarios = [];
    this.userService.getUsuarios().subscribe(result => {
      this.usuarios = result;
      this.recargarTabla();
   
    }, (error) => {
      this.router.navigate(['/']);
    });
  }

  eliminarUsuario(id: any) {
    Swal.fire({
      title: 'Atención!',
      text: 'Esta seguro de desactivar el usuario?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    }).then(respuesta => {
      if(respuesta.isConfirmed){
        this.userService.deleteUsuario(id).subscribe(result=>{
          Swal.fire('Usuario Desactivado!','El usuario ha sido desactivado con exito','success');
          this.recargarTabla();
          this.getUsuarios();
        });
      }
    })
  }

  recargarTabla() {
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
    } else {
      this.isDtInitialized = true
      this.dtTrigger.next();
    }

  }
  editarUsuario(usuario:any) {
    this.usuarioEditado=usuario;
    this.router.navigate(["/editar-usuario"]);
  }

  activarUsuario(id:any){
    Swal.fire({
      title: 'Atención!',
      text: 'Esta seguro de Activar el usuario?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    }).then(respuesta => {
      if(respuesta.isConfirmed){
        this.userService.activarUsuario(id).subscribe(result=>{
          Swal.fire('Usuario Activado!','El usuario ha sido Activado con exito','success');
          this.recargarTabla();
          this.getUsuarios();
        });
      }
    })
  }
}
